import React, { useContext, useEffect } from 'react';
import UserContext from '../context/UserContext';
import { Redirect } from 'react-router-dom';
import CheckOut from './CheckOut';
const CartItems = () => {
	const context = useContext(UserContext);
	useEffect(() => {
		context.changeTotal();
	}, []);
	if (context.pay) return <Redirect to="/CheckOut" />;
	if (!context.cart) return <Redirect to="/viewItems" />;
	return (
		<div className="cartItem__container">
			<div className="cartItem__container__navbar">
				<div className="cartItem__heading__warpper">
					<div className="cartItem__heading">
						<h1 className="cartItem__title">Your Cart</h1>
						<div className="cartItem__backHome">
							<button onClick={() => context.setCart(false)}>
								Back to Home
							</button>
						</div>
					</div>
				</div>

				<div className="cartItem__totol__wrapper">
					{context.cartItem.length > 0 ? (
						<div className="cartItem__total">
							<h2>Total= </h2>
							<div className="cartItem__totalAmount">
								<h2>${context.total}</h2>
							</div>
							<div className="cartItem__buyButton">
								<button
									onClick={() => context.setPay(true)}
									className="button cartItem__butButton"
								>
									Check Out 🛒
								</button>
							</div>
						</div>
					) : (
						''
					)}
				</div>
			</div>

			{context.cartItem.length > 0 ? (
				<div className="cartItem__wrapper">
					{context.cartItem.map((item) => (
						<div className="cartItem__body" key={item.id}>
							<div className="cartItem__img">
								<img src={item.img} alt={item.category} />
							</div>
							<div className="cartItem__details">
								<div className="cartItem__name">
									<h5>{item.productName}</h5>
								</div>
								<div className="cartItem__price">${item.productPrice}</div>
								<div className="cartItem__noItems">
									<h4>No. Items</h4>
									<div className="cartItem__noItem__text">
										<input
											type="number"
											min="1"
											placeholder="1"
											step="1"
											value={item.noItem}
											onChange={(e) => context.changeNoItem(item, e)}
										></input>
									</div>
								</div>
								<div className="cartItem__remove">
									<button
										className="cartItem__remove__button"
										onClick={() => context.removeCartItem(item)}
									>
										Remove from Cart
									</button>
								</div>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className="cartItem__empty">Your Cart is Empty..🛒🛒🛒</div>
			)}
		</div>
	);
};
export default CartItems;
